import { useTranslation } from "react-i18next";

import { Header, PageWrapper } from "~/components";
import { FileManagerTable } from "~/components/FileManager/FileManagerTable";
import { FileManagerTableFilter } from "~/components/FileManager/FileManagerTableFilter";
import { useGetFileManager } from "~/hooks/useGetFileManager";
import { useTableSearchParams } from "~/hooks/useTableSearchParams";

const PAGE_SIZE = 5;

export const MODAL_TYPE_OPTIONS = {
  EDIT: "edit",
  VIEW: "view",
  INVITE: "invite",
  DELETE: "delete",
} as const;

export type ModalType =
  (typeof MODAL_TYPE_OPTIONS)[keyof typeof MODAL_TYPE_OPTIONS];

export const FileManager = () => {
  const { t } = useTranslation();

  const {
    currentPage,
    setCurrentPage,
    search,
    setSearchText,
    sorting,
    orderBy,
    sortDirection,
    setSorting,
  } = useTableSearchParams();

  const { fileManagerData, isLoadingFileManager, totalFileManager } =
    useGetFileManager(currentPage, orderBy, search, sortDirection, PAGE_SIZE);

  const total = totalFileManager;

  return (
    <PageWrapper>
      <div className="mb-4 flex w-full flex-col gap-3">
        <Header
          title={t("file_manager.file_manager")}
          badgeText={
            total != undefined
              ? total === 1
                ? t("file_manager.file_count_one", { count: total })
                : t("file_manager.file_count_other", { count: total })
              : undefined
          }
        />
        <FileManagerTableFilter setSearchText={setSearchText} />
      </div>
      <FileManagerTable
        fileManager={fileManagerData?.data ?? []}
        isLoading={isLoadingFileManager}
        currentPage={currentPage}
        setCurrentPage={setCurrentPage}
        totalItems={totalFileManager}
        pageSize={PAGE_SIZE}
        sorting={sorting}
        setSorting={setSorting}
      />
    </PageWrapper>
  );
};
